var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page-wrapper personalized-sites-wrap"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('breadcrumb', {
    attrs: {
      "items": _vm.breadcrumbItems
    }
  }), _c('div', {
    staticClass: "page-title"
  }, [_c('h1', [_vm._v("Personalized Sites")]), _c('custom-button', {
    attrs: {
      "iconClass": "fas fa-edit"
    },
    on: {
      "onClicked": _vm.editSite
    }
  })], 1), _c('div', {
    staticClass: "row personalized-sites"
  }, [_c('PersonalizedSiteTable', {
    attrs: {
      "rows": _vm.rows
    }
  })], 1)], 1), _c('PersonalizedSiteEdit', {
    attrs: {
      "webAccessCode": _vm.webAccessCode,
      "updateUrl": _vm.updateLandingPageUrl
    },
    on: {
      "onSuccess": _vm.getSites
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }